import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Button, DialogActions, DialogContent, DialogContentProps, DialogTitle, Typography } from '@mui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

type TypeProps = {
    description: React.ReactNode | string;
    title?: React.ReactNode | string;
    icon?: React.ReactNode;
    btn?: {
        onClick: () => void;
        text: string;
        startIcon?: ReactNode;
    };
    secondaryBtn?: {
        onClick: () => void;
        text: string;
        startIcon?: ReactNode;
    };
};

const SuccessActionsElement = ({ btn, secondaryBtn }: Omit<TypeProps, 'description'>) => (
    <>
        {secondaryBtn ? (
            <Button
                fullWidth
                className="rounded-full black-border"
                color="secondary-alt"
                onClick={secondaryBtn?.onClick}
                startIcon={secondaryBtn?.startIcon ?? undefined}
            >
                <Typography fontWeight={500} fontSize={15} letterSpacing={0.46}>
                    {secondaryBtn?.text}
                </Typography>
            </Button>
        ) : null}
        {btn ? (
            <Button
                fullWidth
                className="rounded-full black-border"
                onClick={btn?.onClick}
                startIcon={btn?.startIcon ?? undefined}
            >
                <Typography fontWeight={500} fontSize={15} letterSpacing={0.46}>
                    {btn?.text}
                </Typography>
            </Button>
        ) : null}
    </>
);

type SuccessDialogContentProps = TypeProps & DialogContentProps;

const SuccessDialogContent = ({ description, title, icon, btn, secondaryBtn, ...props }: SuccessDialogContentProps) => (
    <>
        <DialogTitle className="pb-0">
            <div className="flex items-center justify-center size-14 rounded-full border-2 mx-auto">
                {icon ?? <CheckRoundedIcon className="size-6" />}
            </div>
            <Typography fontSize={32} fontFamily="museo-sans" textAlign="center" letterSpacing={-0.8} py={1}>
                {title ?? <FormattedMessage id="dialog.success.title" defaultMessage="Success!" />}
            </Typography>
        </DialogTitle>
        <DialogContent
            {...props}
            className={clsx('text-center h-full flex items-center justify-center', props.className)}
        >
            <Typography fontSize={16}>{description}</Typography>
        </DialogContent>
        {btn || secondaryBtn ? (
            <DialogActions className="w-full flex gap-3">
                {btn || secondaryBtn ? <SuccessActionsElement btn={btn} secondaryBtn={secondaryBtn} /> : null}
            </DialogActions>
        ) : null}
    </>
);

export { SuccessDialogContent };
export type { SuccessDialogContentProps };
